export default __webpack_public_path__ + "static/media/ana-intro.ed77b6db.mp3";